exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".species-selector-image[data-v-cd20296e] {\n  max-width: 60px;\n}\n@media (min-width: 600px) {\n.species-selector-image[data-v-cd20296e] {\n      max-width: 90px;\n}\n}\n@media (min-width: 1024px) {\n.species-selector-image[data-v-cd20296e] {\n      max-width: 150px;\n}\n}\n", ""]);

